<div class="modal-backdrop" (click)="close.emit()">
  <div class="custom-modal-dialog" (click)="$event.stopPropagation()">
    <!-- Modal Head -->
    <div class="modal-head">
      <div>
        <div class="eyebrow">DETAIL VIEW</div>
        <h2>{{ modalTitle }}</h2>
      </div>
      <button type="button" class="icon-button" (click)="close.emit()" aria-label="Close modal">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <!-- Category Tabs -->
    <div class="tabs-header">
      <button 
        type="button"
        class="tab-btn" 
        [class.active]="activeCategory === 'Profiles Incomplete'" 
        (click)="activeCategory = 'Profiles Incomplete'">
        Incomplete Profiles ({{ incompleteProfiles.length }})
      </button>
      <button 
        type="button"
        class="tab-btn" 
        [class.active]="activeCategory === 'Offers Awaiting Response'" 
        (click)="activeCategory = 'Offers Awaiting Response'">
        Offers Awaiting Response ({{ pendingOffers.length }})
      </button>
      <button 
        type="button"
        class="tab-btn" 
        [class.active]="activeCategory === 'New Companies This Week'" 
        (click)="activeCategory = 'New Companies This Week'">
        New Companies ({{ newCompanies.length }})
      </button>
    </div>

    <!-- Tab 1: Profiles Incomplete -->
    <div *ngIf="activeCategory === 'Profiles Incomplete'" class="tab-content">
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Student</th>
              <th>Department</th>
              <th>Score</th>
              <th>Missing Information</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of incompleteProfiles" (click)="onStudentClick(s)" class="clickable-row">
              <td>
                <div class="person-cell">
                  <div>
                    <strong>{{ s.name }}</strong>
                    <span>{{ s.year }}</span>
                  </div>
                </div>
              </td>
              <td>{{ s.department }}</td>
              <td>
                <div class="readiness-cell">
                  <span class="readiness-score">{{ s.score }}</span>
                </div>
              </td>
              <td>
                <span class="status-pill warning">
                  {{ s.missingFields?.join(', ') || 'Unknown' }}
                </span>
              </td>
            </tr>
            <tr *ngIf="incompleteProfiles.length === 0">
              <td colspan="4" class="empty-cell">No incomplete profiles</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Tab 2: Offers Awaiting Response -->
    <div *ngIf="activeCategory === 'Offers Awaiting Response'" class="tab-content">
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Student</th>
              <th>Company</th>
              <th>Role</th>
              <th>Offer Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of pendingOffers" (click)="item.student ? onStudentClick(item.student) : null" class="clickable-row">
              <td>
                <div class="person-cell">
                  <div>
                    <strong>{{ item.student?.name }}</strong>
                    <span>{{ item.student?.department }}</span>
                  </div>
                </div>
              </td>
              <td>{{ item.job?.company }}</td>
              <td>{{ item.job?.role }}</td>
              <td>
                <span class="status-pill neutral">Awaiting Student Response</span>
              </td>
            </tr>
            <tr *ngIf="pendingOffers.length === 0">
              <td colspan="4" class="empty-cell">No pending offers</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Tab 3: New Companies This Week -->
    <div *ngIf="activeCategory === 'New Companies This Week'" class="tab-content">
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Company</th>
              <th>Role</th>
              <th>Date Added</th>
              <th>Location</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let j of newCompanies" (click)="onJobClick(j)" class="clickable-row">
              <td>
                <div class="person-cell">
                  <div class="company-logo table-logo">{{ j.logo }}</div>
                  <div>
                    <strong>{{ j.company }}</strong>
                    <span>{{ j.status }}</span>
                  </div>
                </div>
              </td>
              <td>{{ j.role }}</td>
              <td>{{ j.postedDate }}</td>
              <td>{{ j.location }}</td>
            </tr>
            <tr *ngIf="newCompanies.length === 0">
              <td colspan="4" class="empty-cell">No new companies this week</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
